import { Clock, Router, Wifi, Cable } from "lucide-react";
import { waLink } from "@/lib/site";
import { Reveal } from "./Reveal";

const HOURS = [
  { day: "Segunda a sexta", time: "9h às 18h", open: true },
  { day: "Sábado", time: "9h às 16h", open: true },
  { day: "Domingo", time: "Fechado", open: false },
];

const FIXES = [
  {
    icon: Router,
    title: "Internet fora do ar?",
    copy: "Reinicie o roteador: tire da tomada por 30 segundos e ligue de novo.",
  },
  {
    icon: Wifi,
    title: "Wi-Fi fraco em um cômodo?",
    copy: "Deixe o roteador no centro da casa, alto e longe de micro-ondas e espelhos.",
  },
  {
    icon: Cable,
    title: "Nada resolveu?",
    copy: "Chama no WhatsApp: nosso time de Bertioga resolve do seu lado.",
  },
];

export default function Support() {
  return (
    <section
      id="suporte"
      data-testid="support-section"
      className="scroll-mt-24 py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.35em] text-violet-400">/ SUPORTE</p>
          <h2 className="mt-5 font-display text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">
            Precisa de ajuda?
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-surface p-8 sm:p-10">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-violet-600/30 bg-violet-600/15">
                  <Clock className="h-5 w-5 text-violet-300" />
                </span>
                <h3 className="font-display text-2xl font-bold">
                  Horários de atendimento
                </h3>
              </div>
              <div className="mt-8 flex-1">
                {HOURS.map((h) => (
                  <div
                    key={h.day}
                    data-testid={`support-hours-${h.day.toLowerCase().replace(/\s+/g, "-")}`}
                    className="flex items-center justify-between border-b border-white/10 py-4"
                  >
                    <span className="text-sm text-white/70">{h.day}</span>
                    <span
                      className={`font-mono text-sm font-bold ${
                        h.open ? "text-white" : "text-white/40"
                      }`}
                    >
                      {h.time}
                    </span>
                  </div>
                ))}
              </div>
              <p className="mt-6 text-xs text-white/40">
                Fora do horário? Manda mensagem no WhatsApp que a gente responde
                no próximo horário útil.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="flex h-full flex-col rounded-2xl border border-white/10 bg-surface p-8 sm:p-10">
              <h3 className="font-display text-2xl font-bold">
                Dúvidas de suporte técnico
              </h3>
              <div className="mt-8 flex-1 space-y-7">
                {FIXES.map((f) => (
                  <div key={f.title} className="flex items-start gap-4">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-violet-600/30 bg-violet-600/15">
                      <f.icon className="h-4.5 w-4.5 h-5 w-5 text-violet-300" />
                    </span>
                    <div>
                      <p className="font-medium">{f.title}</p>
                      <p className="mt-1 text-sm leading-relaxed text-white/60">
                        {f.copy}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <a
                data-testid="support-cta"
                href={waLink("Olá! Preciso de suporte técnico.")}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-9 inline-flex w-fit items-center gap-2 rounded-md bg-violet-600 px-8 py-4 text-sm font-medium text-white shadow-[0_0_30px_rgba(124,58,237,0.4)] transition-colors duration-200 hover:bg-violet-500"
              >
                Chamar no WhatsApp
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
